import { render } from "./admin-form-results.vue?vue&type=template&id=7af63aed&scoped=true"
import script from "./admin-form-results.vue?vue&type=script&lang=js"
export * from "./admin-form-results.vue?vue&type=script&lang=js"

import "./admin-form-results.vue?vue&type=style&index=0&id=7af63aed&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af63aed"],['__file',"src/components/admin-dashboard/ui/admin-form-results.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7af63aed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7af63aed', __exports__)) {
    api.reload('7af63aed', __exports__)
  }
  
  module.hot.accept("./admin-form-results.vue?vue&type=template&id=7af63aed&scoped=true", () => {
    api.rerender('7af63aed', render)
  })

}


export default __exports__